import React from "react"

import "../Styles/_main.scss"
import "../Styles/_vendors.scss"

const Global: React.FC = ({ children }) => {
  return <div>{children}</div>
}

export default Global
